import { hasViewSourcing } from 'core/api/organization-settings';
import { getOrganizationSettings, isRetailer } from 'core/api/user';

export const messageRetailerSourcingFilter = {
  key: 'alkemics.recipients.message_sourcing.status',
  query: 'message_sourcing',
  isAvailable: ({ user } = {}) =>
    isRetailer(user) && hasViewSourcing(getOrganizationSettings(user)),
};
